export default __webpack_public_path__ + "static/SME-Header-d912958de7b677c202cf42ccb5a8c3df.webp";